import { render } from "./PreviewReceipt.vue?vue&type=template&id=646a533a&scoped=true&ts=true"
import script from "./PreviewReceipt.vue?vue&type=script&lang=ts"
export * from "./PreviewReceipt.vue?vue&type=script&lang=ts"

import "./PreviewReceipt.vue?vue&type=style&index=0&id=646a533a&scoped=true&lang=css"

import exportComponent from "/Users/abdulkarim/workspace/public_html/joypurhost/pos2/pos2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646a533a"]])

export default __exports__